import moment, { now } from 'moment';
import React, { useEffect, useState } from 'react';
import { Card, Dimmer, Header, Icon, Loader, Segment, Table } from 'semantic-ui-react';
import { getActiveSubscriptions } from '../../services/subscription';
import './ActiveSubscriptionContainer.less'

const ActiveSubscriptionContainer = () => {
    const [activeSubs, setActiveSubs] = useState([]);
    const [inActiveSubs, setInActiveSubs] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        showLoader();
        getActiveSubscriptions().then(res => {
            if (res.resStatus == 200) {
                setActiveSubs(res.data.filter(sa => sa.subStatus == "Active"));
                setInActiveSubs(res.data.filter(sa => sa.subStatus == "In Trial"))
            }
        }).finally(() => {
            hideLoader();
        })
    }, [])

    const showLoader = () => {
        window.scrollTo({
            top: 0,
            behavior: 'auto'
        });
        document.body.style.overflowY = 'hidden'
        setLoading(true);
    }

    const hideLoader = () => {
        document.body.style.overflowY = 'unset'
        setLoading(false);
    }

    return <div className='active-subs-container'>
        {loading ? <Dimmer active>
            <Loader indeterminate size='massive' />
        </Dimmer> : ''}

        {activeSubs.length || !inActiveSubs.length ? <>
            <Segment.Group>
                <Segment size="massive" className="no-radius">
                    <Header as="h1">
                        <Header.Content>
                            <Icon name='bell' size='small' />
                            Active Subscriptions
                        </Header.Content>
                    </Header>
                </Segment>
            </Segment.Group>
            {activeSubs ? activeSubs.length ? window.innerWidth > 767 ? <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Category</Table.HeaderCell>
                        <Table.HeaderCell>Plan</Table.HeaderCell>
                        <Table.HeaderCell>Last Paid Amount</Table.HeaderCell>
                        <Table.HeaderCell>Last Payment Due On</Table.HeaderCell>
                        <Table.HeaderCell>Last Paid On</Table.HeaderCell>
                        <Table.HeaderCell>Next Payment</Table.HeaderCell>
                        <Table.HeaderCell>Next Payment Due On</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {activeSubs.sort((a, b) => moment(b.lastPaymentDate) - moment(a.lastPaymentDate)).map((subs, i) => <Table.Row>
                        <Table.Cell>{subs.categoryName}</Table.Cell>
                        <Table.Cell>{subs.planName}</Table.Cell>
                        <Table.Cell>${subs.chargedAmount} {subs.price != subs.chargedAmount ? <span className='active-subs-actual-amt'>${subs.price}</span> : ''} </Table.Cell>
                        <Table.Cell>{subs.lastPaymentInvoiceDate ? moment(subs.lastPaymentInvoiceDate).format('LL') : '-'}</Table.Cell>
                        <Table.Cell>{subs.lastPaymentDate ? moment(subs.lastPaymentDate).format('LL') : '-'}</Table.Cell>
                        <Table.Cell>${subs.nextPaymentDue} {subs.price != subs.nextPaymentDue ? <span className='active-subs-actual-amt'>${subs.price}</span> : ''} </Table.Cell>
                        <Table.Cell>{moment(subs.nextPaymentDate || subs.trialEnd).format('LL')}</Table.Cell>
                    </Table.Row>)}
                </Table.Body>
            </Table> : <div className='active-subs-card'>
                {activeSubs.map(subs => <Card fluid>
                    <Card.Content>
                        <Card.Header>{subs.categoryName}</Card.Header>
                        <Card.Meta>{subs.planName}</Card.Meta>
                        <Card.Description>
                            <b>Last Paid Amount:</b> ${subs.chargedAmount} {subs.price != subs.chargedAmount ? <span className='active-subs-actual-amt'>${subs.price}</span> : ''}
                        </Card.Description>
                    </Card.Content>
                    <Card.Content>
                        <Card.Description>
                            <b>Last Payment Due On:</b> {moment(subs.lastPaymentInvoiceDate).format('LL')}
                        </Card.Description>
                    </Card.Content>
                    <Card.Content>
                        <Card.Description>
                            <b>Last Paid On:</b> {moment(subs.lastPaymentDate).format('LL')}
                        </Card.Description>
                    </Card.Content>
                    <Card.Content>
                        <Card.Description>
                            <b>Next Payment:</b> ${subs.nextPaymentDue} {subs.price != subs.nextPaymentDue ? <span className='active-subs-actual-amt'>${subs.price}</span> : ''}
                        </Card.Description>
                    </Card.Content>
                    <Card.Content>
                        <Card.Description>
                            <b>Next Payment Due On:</b> {moment(subs.nextPaymentDate).format('LL')}
                        </Card.Description>
                    </Card.Content>
                </Card>)}
            </div> : <div className='active-subs-msg'>No active subscription found</div> : ''}
        </> : "" }

        {inActiveSubs.length ? <> <Segment.Group>
            <Segment size="massive" className="no-radius">
                <Header as="h1">
                    <Header.Content>
                        <Icon name='stopwatch' size='small' />
                        Trial Subscriptions
                    </Header.Content>
                </Header>
            </Segment>
        </Segment.Group>
        {window.innerWidth > 767 ? <Table celled>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>Category</Table.HeaderCell>
                    <Table.HeaderCell>Plan</Table.HeaderCell>
                    <Table.HeaderCell>Next Payment</Table.HeaderCell>
                    <Table.HeaderCell>Next Payment Due On</Table.HeaderCell>
                </Table.Row>
            </Table.Header>

            <Table.Body>
                {inActiveSubs.sort((a, b) => moment(b.lastPaymentDate) - moment(a.lastPaymentDate)).map((subs, i) => <Table.Row>
                    <Table.Cell>{subs.categoryName}</Table.Cell>
                    <Table.Cell>{subs.planName}</Table.Cell>
                    <Table.Cell>${subs.nextPaymentDue} {subs.price != subs.nextPaymentDue ? <span className='active-subs-actual-amt'>${subs.price}</span> : ''} </Table.Cell>
                    <Table.Cell>{moment(subs.trialEnd).format('LL')}</Table.Cell>
                </Table.Row>)}
            </Table.Body>
        </Table> : <div className='active-subs-card'>
            {inActiveSubs.map(subs => <Card fluid>
                <Card.Content>
                    <Card.Header>{subs.categoryName}</Card.Header>
                    <Card.Meta>{subs.planName}</Card.Meta>
                </Card.Content>
                <Card.Content>
                    <Card.Description>
                        <b>Next Payment:</b> ${subs.nextPaymentDue} {subs.price != subs.nextPaymentDue ? <span className='active-subs-actual-amt'>${subs.price}</span> : ''}
                    </Card.Description>
                </Card.Content>
                <Card.Content>
                    <Card.Description>
                        <b>Trial End:</b> {moment(subs.trialEnd).format('LL')}
                    </Card.Description>
                </Card.Content>
            </Card>)}
        </div>}
    </> : ''}
    </div>
}

export default ActiveSubscriptionContainer;